<template v-if="headerGet">
  <div>
  <div class="title animated fadeIn" v-bind:class="{ headerNoAvatarYes: !headerGet && avatarGet }" v-if="!headerGet">
      <div class="title--inner">
        <span v-if="!logoGet && !headerGet" class="title-sapient animated fadeIn"><img src="static/svg/logo-sapient.svg" alt="Publicis Sapient" width="65"></span>
        <h1 v-if="!titleGet && !headerGet" class="animated fadeIn h1" v-html="$t(`title_${currentTab}`)"></h1>

        <div class="title--slot">
            <slot />
        </div>
      </div>
  </div>
  <div class="title animated fadeIn noHeader" v-if="headerGet && avatarGet">
    <div class="title--slot">
        <slot />
    </div>
  </div>
  </div>
</template>

<script>
import Utils from '../utils';
export default {
  name: 'ESTitle',
  props: ['currentTab'],
  data: function () {
    return {
      headerGet: Utils.findGetParameter('header') && String(Utils.findGetParameter('header')) === 'false',
      logoGet: Utils.findGetParameter('logo') && String(Utils.findGetParameter('logo')) === 'false',
      titleGet: Utils.findGetParameter('title') && String(Utils.findGetParameter('title')) === 'false',
      avatarGet: Utils.findGetParameter('avatar') && String(Utils.findGetParameter('avatar')) === 'true',
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Title.vue